import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

const getStats = async (proyectoId, version) => {
  const resp = await axios.get(`/api/v1/tipos/${proyectoId}/stats/${version}`)
  return resp.data
}

export const useStats = (proyectoId, version) => {
  const { data, isLoading, error } = useQuery(
    ['stats', `${proyectoId}-${version}`],
    () => getStats(proyectoId, version)
  )

  return { data, isLoading, error }
}
